import { createContext } from "react";

const TipoClienteContext = createContext();

export default TipoClienteContext;
